import { createSlice } from '@reduxjs/toolkit';
export const initialState = {
    request: {
        isLoadingStepDetails: true,
    },
    data: {
        step: null,
    },
};
export const appSlice = createSlice({
    name: 'app',
    initialState,
    reducers: {
        getStepDetails: (state, _action) => {
            state.request.isLoadingStepDetails = true;
        },
        storeAppStepDetails: (state, action) => {
            state.data.step = action.payload;
            state.request.isLoadingStepDetails = false;
        },
    },
});
export const { getStepDetails, storeAppStepDetails } = appSlice.actions;
export default appSlice.reducer;
